// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"c92251d6","733":"c92251d6"}[chunkId] + ".chunk.css";
};